import React from 'react';
import styles from './PricingPlan.module.css'; // Adjust the path as necessary
import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { handleUpgradeSubscription } from '../../../services/paymentService';
import toast from 'react-hot-toast';
import { fetchUserByToken } from '../../../app/features/userSlice';

const Plan = ({ email, title, description, link, priceId, currentIndex, activeSubscriptionIndex, price, discount, buttonText }) => {
    const user = useSelector(state => state.user.user);
    const userToken = useSelector(state => state.user.token);
    const dispatch = useDispatch(null)
    const handleButtonClick = () => {
        window.location.href = link +
            '?prefilled_email=' +
            email; // Open the link in the same tab
    };

    return (
        <div className={styles.plan}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
            <h2 className={styles.price}>{price}</h2>
            <p className={styles.saveDisk}>{discount}</p>
            <button
                // disabled
                className={`${activeSubscriptionIndex > currentIndex ? styles.disableButton : buttonText == t('billing.activeStatus') ? styles.activeButton : styles.button} `}
                onClick={() => {
                    // if (buttonText == t('plans.1_month_plan.button_upgrade_text')) {

                    //     toast.promise(handleUpgradeSubscription(priceId, userToken), {
                    //         loading: t('general.UI.loading'),
                    //         success: <b>{t('plans.1_month_plan.upgradeSucces')}</b>,
                    //         error: (err) => {
                    //             return <b>{t('general.UI.something_went_wrong')}</b>;
                    //         },
                    //     }).then(() => {
                    //         dispatch(fetchUserByToken(userToken));
                    //     })
                    // } else 
                    if (buttonText !== t('billing.activeStatus') && activeSubscriptionIndex < currentIndex) {
                        handleButtonClick()
                    }
                }}>{buttonText}</button>
        </div >
    );
};

export default Plan;
